import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

export const MARIMO_NOTEBOOK_EDIT_PATH = `${PROJECT_BASE_PATH}/notebooks/:notebookId/edit`;

export function marimoNotebookEditPath({
  notebookId,
  entityName,
  projectName,
}: {
  notebookId: string;
  entityName: string;
  projectName: string;
}): string {
  return `/${entityName}/${projectName}/notebooks/${encodeURIComponent(
    notebookId
  )}/edit`;
}
